import {
  queryDataDictionaryListLang,
  searchStoreList,
  myAppList,
  resourceListByRole,
  menuListByRole,
  queryDistrict
} from "@/graphql/Common.gql";
import { getLanguages, queryShopInfo, getMember, sendSmsCode } from "@/graphql/Root.gql";
import { easyMutate, resRest } from "@root/lib/utils";
import {
  K1_YGJ_apolloClient
} from "@root/lib/allApolloClient";
import { httpServer as http } from "@/lib/axios";
// import { i18n } from "@/main";

// 将数据转为map
export const expandArrayToMap = (
  list,
  { labelKey = "label", valueKey = "value" } = {}
) => {
  if (!list) return {};
  const result = {};
  list.forEach(item => {
    const value = item[valueKey];
    const label = item[labelKey];

    // value有可能是以逗号连接的多个值的组合
    if (value.indexOf(",") > -1) {
      value.split(",").forEach(key => (result[key] = label));
    } else {
      result[value] = label;
    }
  });

  return result;
};

const datalistToMap = list => {
  return list.map(v => v.node);
};

export default {
  namespaced: true,
  state: {
    languageList: [],
    serviceOrderStatusList: [],
    orderStatusList: [],
    paymentTypeList: [],
    tradeSourceList: [],
    refundTypeList: [],
    refundApplyTypeList: [],
    refundStatusList: [],
    channelList: [],
    payStatusList: [],
    cancelReasonList: [],
    carrierList: [],
    subTypeList: [],
    orderTypeList: [],
    storeList: [],
    menuList: [],
    deductionTypeList: [],
    returnReasonList: [],
    returnStatusList: [],
    distributionTypeList: [],
    nodeList: [],
    onlineStores: [],
    returnMethodList: [],
    pickupMethodList: [],
    interfaceLogFailTypeList: [],
    interfaceLogStatusList: [],
    orderCommentReplyStatusList: [],
    fulfillRefundStatusList: [],
    orderExpressStatusList: [],
    orderFrozenReasonTypeList: [],
    orderProductStatusList: [],
    DOOrderStatusList: [],
    permission: {},
    tenantCode: "",
    myCountry: "",
    myProvince: "",
    myCity: "",
    myDistrict: "",

    wtDicCodes: {}
  },
  getters: {
    serviceOrderStatusListMap(state) {
      return expandArrayToMap(state.serviceOrderStatusList);
    },
    orderStatusMap(state) {
      return expandArrayToMap(state.orderStatusList);
    },
    paymentTypeMap(state) {
      return expandArrayToMap(state.paymentTypeList);
    },
    tradeSourceMap(state) {
      return expandArrayToMap(state.tradeSourceList);
    },
    refundTypeMap(state) {
      return expandArrayToMap(state.refundTypeList);
    },
    refundApplyTypeMap(state) {
      return expandArrayToMap(state.refundApplyTypeList);
    },
    refundStatusMap(state) {
      return expandArrayToMap(state.refundStatusList);
    },
    channelListMap(state) {
      return expandArrayToMap(state.channelList);
    },
    payStatusListMap(state) {
      return expandArrayToMap(state.payStatusList);
    },
    cancelReasonListMap(state) {
      return expandArrayToMap(state.cancelReasonList);
    },
    carrierListMap(state) {
      return expandArrayToMap(state.carrierList);
    },
    subTypeListMap(state) {
      return expandArrayToMap(state.subTypeList);
    },
    orderTypeListMap(state) {
      return expandArrayToMap(state.orderTypeList);
    },
    deductionTypeListMap(state) {
      return expandArrayToMap(state.deductionTypeList);
    },
    returnReasonListMap(state) {
      return expandArrayToMap(state.returnReasonList);
    },
    returnStatusListMap(state) {
      return expandArrayToMap(state.returnStatusList);
    },
    distributionTypeListMap(state) {
      return expandArrayToMap(state.distributionTypeList);
    },
    returnMethodListMap(state) {
      return expandArrayToMap(state.returnMethodList);
    },
    pickupMethodListMap(state) {
      return expandArrayToMap(state.pickupMethodList);
    },
    interfaceLogFailTypeMap(state) {
      return expandArrayToMap(state.interfaceLogFailTypeList);
    },
    interfaceLogStatusMap(state) {
      return expandArrayToMap(state.interfaceLogStatusList);
    },
    orderCommentReplyStatusMap(state) {
      return expandArrayToMap(state.orderCommentReplyStatusList);
    },
    fulfillRefundStatusMap(state) {
      return expandArrayToMap(state.fulfillRefundStatusList);
    },
    orderExpressStatusMap(state) {
      return expandArrayToMap(state.orderExpressStatusList);
    },
    orderFrozenReasonTypeMap(state) {
      return expandArrayToMap(state.orderFrozenReasonTypeList);
    },
    orderProductStatusMap(state) {
      return expandArrayToMap(state.orderProductStatusList);
    },
    DOOrderStatusMap(state) {
      return expandArrayToMap(state.DOOrderStatusList);
    },
    menuList(state) {
      return state.menuList.map(
        ({ menuName: name, menuIcon: icon, pageUrl: path }) => {
          return {
            name,
            icon,
            path
          };
        }
      );
    }
  },
  actions: {
    // 获取当前租
    async getLanguages({ commit, rootState }, ddCode = "LANGUAGE_CODE") {
      const {
        data: resData,
        data: {
          tenantLanguages: { languages }
        }
      } = await rootState.gql.query({
        query: getLanguages,
        variables: {
          input: {
            ddCode
          }
        }
      });

      const allList = resRest(resData);
      const resultList = (languages.split(";") || []).map(val => {
        const { value, label } = allList.find(item => item.value === val);
        return { value, label };
      });

      commit("easyMutate", {
        data: resultList,
        path: "languageList"
      });
    },
    // appList
    async getAppList({ rootState }, data) {
      let res = await rootState.gql.query({ query: myAppList });
      return res.data.queryMyAppList || [];
    },
    // 字典
    async queryDataDictionaryListLang(
      { commit, rootState },
      { statePath: path, ddCode }
    ) {
      // const tenantCode = localStorage.tenantCode
      const res = await rootState.gql.query({
        query: queryDataDictionaryListLang,
        variables: {
          input: {
            lang: "zh-cn",
            ddCode
          }
        }
      });

      commit("easyMutate", {
        path,
        data: res.data.api || []
      });

      return res.data.api;
    },

    // 模糊查新门店列表
    async searchStoreList(
      { commit, rootState },
      {
        pageInput = { pageSize: 1000, pageNum: 1 },
        searchKey = "",
        cb = list =>
          list.filter(item => item.status === 1 && item.openStatus === 1)
      }
    ) {
      const res = await rootState.gql.query({
        query: searchStoreList,
        variables: {
          pageInput,
          searchKey
        }
      });

      const list = resRest(res.data);

      commit("easyMutate", {
        path: "storeList",
        data: cb ? cb(list) : list
      });
    },

    // 权限
    // async resourceListByRole({ commit, rootState }, resourceParent) {
    //   const {
    //     data: { api: list }
    //   } = await rootState.gql.query({
    //     query: resourceListByRole,
    //     variables: {
    //       resourceParent
    //     }
    //   });

    //   const permission = {};

    //   list.map(
    //     ({ positionCode: key = null }) => key && (permission[key] = true)
    //   );

    //   // commit("easyMutate", { path: "permission", data: permission });
    // },

    // 菜单
    async menuListByRole({ commit, rootState }) {
      const {
        data: { api: menu }
      } = await rootState.gql.query({
        query: menuListByRole
      });
      commit("easyMutate", { path: "menuList", data: menu });
    },

    // permission
    permissionIt({ state }, key) {
      return state.permission.hasOwnProperty(key);
    },

    // 获取省市区
    async queryDistrict({ rootState, commit, state }, data = {}) {
      const tenantCode = localStorage.getItem("tenantCode") || "";

      const variables = Object.assign(
        {},
        {
          pageInput: {
            pageSize: 10000,
            pageNum: 1
          },
          input: {
            districtPcode: data,
            tenantCode
          }
        }
      );

      const {
        data: { api }
      } = await rootState.gql.query({
        query: queryDistrict,
        variables
      });

      return datalistToMap(api.datalist);
    },
    async queryShopInfo({ commit, rootState }, variables) {

      const {
        data,
        data: {
          api: { pageInfo }
        }
      } = await rootState.gql.query({
        query: queryShopInfo,
        variables: variables
      });

      let list = resRest(data);

      return {
        // total: pageInfo.totalCount,
        list: list || []
      };
    },

    async getMember({ rootState }: any, params?: any) {
      let { data } = await K1_YGJ_apolloClient.query({
        query: getMember,
        variables: { ...params }
      });
      return data ? data.api : {};
    },
    async getDataValue({ rootState }, params = {}) {
      const data = await http(
        "/basic/getDataValue",
        params
      );
      return data.data;
    },
    async getDict({ rootState, commit }, params = {}) {
      const data = await http(
        "/dict/list",
        params
      );
      let list: any = data.data || [];
      let dicMap: any = {};
      list.forEach(_ => {
        dicMap[_.code] = _.value || [];
      });

      commit('setWtDicCodes', dicMap);

      return list;
    },

    // 门店下拉列表
    async storeSimpleSubPaging({ rootState }, params: any = {}) {
      const { searchKey = "", pageInput: { pageNum = 1, pageSize = 10 } = {} } =
        params || {};

      const data = await http(
        "/store/simpleSubPaging",
        {
          searchKey: searchKey,

          pageSize,
          pageNum,
        }
      );
      return data.data || { list: [], total: 0 }
    },
    async queryDictList({ rootState }, params = {}) {
      const data = await http("/basic/queryDictList", params);
      return data;
    }

    // /dict/list
  },
  mutations: {
    easyMutate,
    setWtDicCodes(state, data) {
      state.wtDicCodes = {
        ...state.wtDicCodes, ...data
      };
    }
  }
};
